import { Component, NgZone, OnInit } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { ModalConfig, ModalService } from '@freelancer/ui';
import { ModalResult } from '@freelancer/ui/modal';
import { HireMeWebappModalComponent } from 'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component';
import { ArrowLoginSignupModalComponent } from 'app/login-signup/arrow-login-signup-modal/arrow-login-signup-modal.component';
import { PaymentShareModalComponent } from 'app/payments/payment-share-modal/payment-share-modal.component';
import { PaymentsModalComponent } from 'app/payments/payments-deposit/payments-modal/payments-modal.component';
import { AwardModalComponent } from 'app/projects/award-modal/award-modal.component';
import { PaymentShareMemberModalComponent } from '../app/payments/payment-share-member-modal/payment-share-member-modal.component';

export const MODALS_MAP = {
  AwardModalComponent,
  ArrowLoginSignupModalComponent,
  HireMeWebappModalComponent,
  PaymentsModalComponent,
  PaymentShareModalComponent,
  PaymentShareMemberModalComponent,
};

@Component({
  selector: 'webapp-compat-modals',
  template: `
    <fl-modal></fl-modal>
  `,
})
export class CompatModalsComponent implements OnInit {
  constructor(
    private auth: Auth,
    private ngZone: NgZone,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    const w = window as any;
    w.webappCompatModals = {
      open: (
        componentName: keyof typeof MODALS_MAP,
        config: ModalConfig,
        afterClosedCallback?: (result?: ModalResult) => void,
      ) =>
        this.ngZone.run(() =>
          this.modalService
            .open(MODALS_MAP[componentName] as any, config)
            .afterClosed()
            .toPromise()
            .then(result => {
              if (afterClosedCallback) {
                afterClosedCallback(result);
              }
              return result;
            }),
        ),
      // this is used for backwards compatibility reasons to set the credentials from the old stack
      setSession: (userId: string, token: string) =>
        this.ngZone.run(() => {
          this.auth.setSession(userId, token);
        }),
    };
    if (w.webappCompatModalsReadyCallback) {
      w.webappCompatModalsReadyCallback();
    }
  }
}
